window.Products.Clothing.ScoopBralette = function() {
};
window.Products.Clothing.ScoopBralette.inherits(window.Products.Clothing.Clothing);
window.Products.Clothing.ScoopBralette.dpi = 150;
window.Products.Clothing.ScoopBralette.has_3d = true;
window.Products.Clothing.ScoopBralette.id = 98;
window.Products.Clothing.ScoopBralette.slug = 'scoop-bralette';
window.Products.Clothing.ScoopBralette.use_glb = true;

window.Products.Clothing.ScoopBralette.prototype.outsideObject = 1;
window.Products.Clothing.ScoopBralette.prototype.insideObject = 0;
window.Products.Clothing.ScoopBralette.prototype.detailsObject = 2;
window.Products.Clothing.ScoopBralette.prototype.detailsInsideObject = 3;

window.Products.Clothing.ScoopBralette.prototype.set3dProperties = function(modelViewer) {
	modelViewer.setFixedView('front');
	modelViewer.object.position.y = -0.6;

	this.updateThreeTexture(modelViewer);

	modelViewer.object.children[0].children[this.insideObject].material.transparent = true;
	modelViewer.object.children[0].children[this.insideObject].material.opacity = 0.95;
	modelViewer.object.children[0].children[this.outsideObject].material.side = THREE.DoubleSide;

	modelViewer.object.children[0].children[this.outsideObject].material.aoMapIntensity = 0.9;
	
	modelViewer.object.children[0].children[this.insideObject].material.aoMapIntensity = 3;
	modelViewer.object.children[0].children[this.insideObject].material.color.r = 0.9;
	modelViewer.object.children[0].children[this.insideObject].material.color.g = 0.9;
	modelViewer.object.children[0].children[this.insideObject].material.color.b = 0.9;

	modelViewer.object.children[0].children[this.detailsObject].material.aoMapIntensity = 0.3;
	modelViewer.object.children[0].children[this.detailsInsideObject].material.aoMapIntensity = 0.3;

};

window.Products.Clothing.ScoopBralette.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.texture.flipY = false;
	modelViewer.object.children[0].children[this.outsideObject].material.map = modelViewer.texture;
	modelViewer.object.children[0].children[this.detailsObject].material.map = modelViewer.texture;
};

window.Products.Clothing.ScoopBralette.prototype.setThreeControls = function(controls) {
	controls.minDistance = 16;
	controls.maxDistance = 22;
};